// Spanish labels of every role, shared by Gestión de Usuarios and its Informes.
// Copied in gfunctions/users/userReports/reportLogic.js (a function package
// cannot require src/); roleLabels.test.js keeps the two equal.

export const ALL_ROLES = [
  { key: "ADMIN", label: "Administrador" },
  { key: "ADMIN_USER", label: "Administrador de Usuarios" },
  { key: "ARCHIVER", label: "Archivador" },
  { key: "EXPEDIENTS", label: "Expedientes" },
  { key: "USER", label: "Usuario" },
  { key: "ADMIN_CONTRACT", label: "Admin Contratos" },
  { key: "ADMIN_CONTRACT_LEGAL", label: "Admin Contratos P. Jurídica" },
  { key: "SUPERVISOR_CONTRACT", label: "Supervisor Contratos" },
  { key: "SUPERVISOR_LEGAL_CONTRACT", label: "Supervisor Contratos P. Jurídica" },
  { key: "SUPPORT_SUPERVISION", label: "Apoyo a la Supervisión" },
  { key: "CONTRACTOR", label: "Contratista" },
  { key: "CONTRACTOR_LEGAL", label: "Contratista Persona Jurídica" },
  { key: "FINANCIER", label: "Actas de Pago" },
  // Áreas del recorrido financiero de facturas de persona jurídica (acta #3).
  { key: "PAYMENT_CAUSATION", label: "Gestión de Pagos — Causación" },
  { key: "PAYMENT_ACCOUNTING", label: "Gestión de Pagos — Contabilidad" },
  { key: "PAYMENT_BUDGET", label: "Gestión de Pagos — Presupuesto" },
  { key: "PAYMENT_TREASURY", label: "Gestión de Pagos — Tesorería" },
  { key: "PAYMENT_CASHIER", label: "Gestión de Pagos — Caja" },
  { key: "EXTENSION_APPLICANTS", label: "Extensión — Gestor de Aspirantes" },
  { key: "EXTENSION_AGREEMENTS", label: "Extensión — Convenios" },
  { key: "EXTENSION_ENTITIES", label: "Extensión — Entidades" },
  { key: "PQRSD_SUPERVISOR", label: "Supervisor PQRSD" },
  { key: "PQRSD_DEPENDENCY_SUPERVISOR", label: "Supervisor de dependencia PQRSD" },
  { key: "PQRSD_OPERATOR", label: "Operario PQRSD" },
  { key: "PQRSD_WINDOW", label: "Ventanilla PQRSD" },
  { key: "PQRSD_CONFIG", label: "Configuración PQRSD IA" },
  { key: "PQRSD_ANALYST", label: "Informes PQRSD" },
];

// Company-user roles are deliberately NOT in ALL_ROLES: they are not granted by
// hand. An ENTITY user comes from their company's public registration or from an
// administrator's invitation, never from staff sign-up. Only their label is
// registered here, so the management tab knows how to display them if one ever
// shows up in the list.
export const ENTITY_ROLE_LABELS = {
  ENTITY_ADMIN: "Empresa — Administrador",
  ENTITY_MEMBER: "Empresa — Personal",
};

export const ROLE_LABELS = {
  ...Object.fromEntries(ALL_ROLES.map((r) => [r.key, r.label])),
  ...ENTITY_ROLE_LABELS,
};

// The role columns of the Informes de Usuarios list, grouped by module the way
// the institution's own user list groups them, with its short column names:
// [role, short name]. Its four modules (COMUNICACIONES, RADICAR, CONTRATOS,
// EXPEDIENTES) come first. Copied in gfunctions/users/userReports/reportLogic.js.
// Its CONTRATOS / RENDICIÓN column is ADMIN_CONTRACT; EXPEDIENTES has no role
// name under it, as in its list.
export const ROLE_GROUPS = [
  { label: "COMUNICACIONES", roles: [["USER", "user"]] },
  { label: "RADICAR", roles: [["ARCHIVER", "archiver"]] },
  {
    label: "CONTRATOS",
    roles: [
      ["ADMIN_CONTRACT", "RENDICIÓN"],
      ["SUPERVISOR_CONTRACT", "SUPERVISOR"],
      ["CONTRACTOR", "CONTRATISTA"],
      ["SUPPORT_SUPERVISION", "APOYO SUPER"],
      ["ADMIN_CONTRACT_LEGAL", "ADMIN CONTRATOS P. JURÍDICA"],
      ["SUPERVISOR_LEGAL_CONTRACT", "SUPERVISOR P. JURÍDICA"],
      ["CONTRACTOR_LEGAL", "CONTRATISTA P. JURÍDICA"],
    ],
  },
  { label: "EXPEDIENTES", roles: [["EXPEDIENTS", ""]] },
  {
    label: "ACTAS Y PAGOS",
    roles: [
      ["FINANCIER", "ACTAS DE PAGO"],
      ["PAYMENT_CAUSATION", "CAUSACIÓN"],
      ["PAYMENT_ACCOUNTING", "CONTABILIDAD"],
      ["PAYMENT_BUDGET", "PRESUPUESTO"],
      ["PAYMENT_TREASURY", "TESORERÍA"],
      ["PAYMENT_CASHIER", "CAJA"],
    ],
  },
  {
    label: "PQRSD",
    roles: [
      ["PQRSD_SUPERVISOR", "SUPERVISOR"],
      ["PQRSD_DEPENDENCY_SUPERVISOR", "SUPERVISOR DEPENDENCIA"],
      ["PQRSD_OPERATOR", "OPERARIO"],
      ["PQRSD_WINDOW", "VENTANILLA"],
      ["PQRSD_CONFIG", "CONFIGURACIÓN IA"],
      ["PQRSD_ANALYST", "INFORMES"],
    ],
  },
  {
    label: "EXTENSIÓN",
    roles: [
      ["EXTENSION_APPLICANTS", "ASPIRANTES"],
      ["EXTENSION_AGREEMENTS", "CONVENIOS"],
      ["EXTENSION_ENTITIES", "ENTIDADES"],
    ],
  },
  { label: "ADMINISTRACIÓN", roles: [["ADMIN", "ADMINISTRADOR"], ["ADMIN_USER", "ADMIN USUARIOS"]] },
  { label: "EMPRESAS", roles: [["ENTITY_ADMIN", "ADMINISTRADOR"], ["ENTITY_MEMBER", "PERSONAL"]] },
];

// The columns of the institution's own list, for the builder's shortcut.
export const INSTITUTIONAL_ROLE_COLUMNS = [
  "USER", "ARCHIVER", "ADMIN_CONTRACT", "SUPERVISOR_CONTRACT", "CONTRACTOR", "SUPPORT_SUPERVISION", "EXPEDIENTS",
];

// Module of each role, for grouping the role pickers.
export const ROLE_GROUP_OF = Object.fromEntries(
  ROLE_GROUPS.flatMap((g) => g.roles.map(([role]) => [role, g.label]))
);
